<div class="table-responsive">
  <div class="card">
    <div class="card-body">
      <!-- Header Section -->
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h2>Entities</h2>
            </div>
            <div class="d-flex align-items-center gap-2">
              <!-- Search Box -->
              <div class="search-container m-0">
                <input type="text" class="search-input" placeholder="Search..." [(ngModel)]="searchTerm" (keyup.enter)="loadEntitiesData(lastTableLazyLoadEvent)">
                <button class="search-button" style="padding-bottom: 3px;" (click)="loadEntitiesData(lastTableLazyLoadEvent)" pTooltip="Search entities" appActionTooltip>
                  <img src="assets/images/search.png" alt="Search">
                </button>
                <button class="search-button sb-close btn-lg" (click)="searchTerm='';loadEntitiesData(lastTableLazyLoadEvent)" pTooltip="Clear search" appActionTooltip><i
                class="mdi mdi-window-close"></i></button>
              </div>

              <button
                class="btn btn-primary btn-sm"
                (click)="loadEntitiesData(lastTableLazyLoadEvent)"
                pTooltip="Refresh table" appActionTooltip>
                <i class="mdi mdi-reload"></i>
              </button>

              <button
                class="btn btn-primary btn-sm"
                (click)="clearFilters(dt)"
                pTooltip="Clear all column filters" appActionTooltip>
                Clear <i class="mdi mdi-filter-remove"></i>
              </button>

              <button
                type="button"
                class="btn btn-success btn-sm"
                (click)="openEntityDialog()"
                pTooltip="Create a new entity" appActionTooltip>
                <i class="mdi mdi-plus"></i> Create Entity
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Entities Table -->
      <p-table
        [lazy]="true"
        #dt
        [columns]="cols"
        (onLazyLoad)="loadEntitiesData($event)"
        [value]="entities"
        dataKey="id"
        styleClass="p-datatable-entities"
        [rowHover]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [loading]="loading"
        responsiveLayout="scroll"
        [paginator]="true"
        [autoLayout]="true"
        [totalRecords]="totalRecords"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="0"
        paginatorDropdownAppendTo="body"
        [globalFilterFields]="['name', 'groupAccountName', 'jurisdictionName']">

        <!-- Table Header -->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <!-- Edit -->
            <th>Edit</th>
            <!-- Group Account -->
            <th pSortableColumn="groupAccountName">
              <div class="flex align-items-center">
                Group Account
                <p-sortIcon field="groupAccountName"></p-sortIcon>
                <p-columnFilter
                  matchMode="contains"
                  [showOperator]="false"
                  [showAddButton]="false"
                  type="text"
                  field="groupAccountName"
                  display="menu">
                </p-columnFilter>
              </div>
            </th>

            <!-- Entity Name -->
            <th pSortableColumn="name">
              <div class="flex">
                Entity Name
                <p-sortIcon field="name"></p-sortIcon>
                <p-columnFilter
                  matchMode="contains"
                  [showOperator]="false"
                  [showAddButton]="false"
                  type="text"
                  field="name"
                  display="menu">
                </p-columnFilter>
              </div>
            </th>

            <!-- Jurisdiction -->
            <th pSortableColumn="jurisdictionName">
              <div class="flex">
                Jurisdiction
                <p-sortIcon field="jurisdictionName"></p-sortIcon>
                <p-columnFilter
                  matchMode="contains"
                  [showOperator]="false"
                  [showAddButton]="false"
                  type="text"
                  field="jurisdictionName"
                  display="menu">
                </p-columnFilter>
              </div>
            </th>

            <!-- Jurisdiction -->
            <th pSortableColumn="jurisdictionIdNumber">
              <div class="flex">
                Jurisdiction Id
                <p-sortIcon field="jurisdictionIdNumber"></p-sortIcon>
                <p-columnFilter
                  matchMode="contains"
                  [showOperator]="false"
                  [showAddButton]="false"
                  type="text"
                  field="jurisdictionIdNumber"
                  display="menu">
                </p-columnFilter>
              </div>
            </th>

            <!-- Associated Project IDs -->
            <th>
              <div class="flex">
                Associated Project IDs
                <p-columnFilter
                  matchMode="contains"
                  [showOperator]="false"
                  [showAddButton]="false"
                  type="text"
                  field="associatedProjectIds"
                  display="menu"
                  placeholder="Search project IDs">
                </p-columnFilter>
              </div>
            </th>

            <!-- Associated Task IDs -->
            <th>
              <div class="flex">
                Associated Task IDs
                <p-columnFilter
                  matchMode="contains"
                  [showOperator]="false"
                  [showAddButton]="false"
                  type="text"
                  field="associatedTaskIds"
                  display="menu"
                  placeholder="Search task IDs">
                </p-columnFilter>
              </div>
            </th>
          </tr>
        </ng-template>

        <!-- Table Body -->
        <ng-template pTemplate="body" let-entity>
          <tr>
            <td><!-- Edit -->
              <span appActionTooltip
                [pTooltip]="entity.disableEditEntityTitle ? entity.disableEditEntityTitle : 'Edit entity'"
                [actionDisabled]="entity.disableEditEntity">
                <button class="btn btn-primary btn-sm" (click)="editEntity(entity)"
                  [disabled]="entity.disableEditEntity">
                  <i class="mdi mdi-pencil"></i>
                </button>
              </span>
            </td>
            <td>{{ entity.groupAccountName || '-' }}</td>
            <td>
              <a
                href="javascript:void(0)"
                class="text-primary entity-name-link"
                (click)="viewEntityDetails(entity)"
                pTooltip="View entity details" appActionTooltip>
                {{ entity.name || '-' }}
              </a>
            </td>
            <td>{{ entity.jurisdictionName || '-' }}</td>
            <td>{{ entity.jurisdictionIdNumber || '-' }}</td>
            <td>
              @if (entity.associatedProjectIds && entity.associatedProjectIds.length > 0) {
                @for (projectId of entity.associatedProjectIds; track $index; let i = $index) {
                  <a
                    href="javascript:void(0)"
                    class="text-primary"
                    (click)="navigateToProject(projectId)"
                    [pTooltip]="'View project ' + projectId" appActionTooltip>
                    {{ projectId }}
                  </a>
                  @if (i < entity.associatedProjectIds.length - 1) {
                    <span>, </span>
                  }
                }
              } @else {
                -
              }
            </td>
            <td>
              @if (entity.associatedTaskIds && entity.associatedTaskIds.length > 0) {
                @for (taskId of entity.associatedTaskIds; track $index; let i = $index) {
                  <a
                    href="javascript:void(0)"
                    class="text-primary"
                    (click)="navigateToTask(taskId)"
                    [pTooltip]="'View task ' + taskId" appActionTooltip>
                    {{ taskId }}
                  </a>
                  @if (i < entity.associatedTaskIds.length - 1) {
                    <span>, </span>
                  }
                }
              } @else {
                -
              }
            </td>
          </tr>
        </ng-template>

        <!-- No Records Template -->
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center">No entities found.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Entity Detail Dialog - Read-Only View -->
@if (entityDetailDialog ) {
  <app-entity-form
    [visible]="entityDetailDialog"
    [entity]="selectedEntity"
    [title]="'Entity Information'"
    [readOnly]="viewOnly"
    [skipIsTKUpdatedEntity]="false"
    (visibleChange)="closeEntityDetailDialog()">
  </app-entity-form>
}